import React, {useState, useEffect} from 'react';
import TableRow from './TableRow';
import TeamTableRow from './TeamTableRow';
import './Table.css';
import useDebounce from './useDebounce';

function Table({members, type, activeTable, idx, url}) {
	const [tableData, setTableData] = useState({
		leaderboard: []
	});
	const [loading, setLoading] = useState(false);
	const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [autoCompleteResults, setAutoCompleteResults] = useState([]);
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

	const getData = () => {
		setLoading(true);

		const fullUrl = (type !== 'Team' ? url + page : url);

		return fetch(fullUrl)
		.then(res => {
			if(!res.ok) throw Error(res);
			return res.json();
		}).then(response => {
			setLoading(false);
			if(type === 'Gym' || type === 'Individual') {
				return setTableData({leaderboard: response});
			}
			return setTableData(response);
		}).catch(res => {
			setLoading(false);
			if(res.json) return console.log(res.statusText);
		 		return console.log(res);
		})
	}

	useEffect(() => {
		if(!url) return;

		getData();

		return () => {};
	}, [url, type, page]);


	useEffect(() => {
		if(debouncedSearchTerm) {
			url = (type !== 'Individual' ? 
				'https://www.beyondthewhiteboard.com/tiggy_home_alone_gym_alltime_scores?q=' + debouncedSearchTerm :
			  'https://www.beyondthewhiteboard.com/tiggy_home_alone_member_alltime_scores?q=' + debouncedSearchTerm + '&public=true');
			fetch(url, {

			}).then(res => {
				if(!res.ok) throw Error(res.statusText);
				return res.json();
			}).then(response => {
				setAutoCompleteResults(response);
			}).catch(e => {
				console.log(e)
			});
		} else {
			setAutoCompleteResults([]);
			setSearchTerm();
		}

		return () => {};
	}, [debouncedSearchTerm]);

	const getMemberPage = (result) => {
			url = (type !== 'Individual' ? 
				'https://www.beyondthewhiteboard.com/tiggy_home_alone_gym_alltime_scores?max_points='+result.points :
			  'https://www.beyondthewhiteboard.com/tiggy_home_alone_member_alltime_scores?max_points='+result.points + '&public=true');
			fetch(url, {
			}).then(res => {
				if(!res.ok) throw Error(res.statusText);
				return res.json();
			}).then(response => {
				setTableData({leaderboard: response});
				setAutoCompleteResults([]);
			});
	}

	if(activeTable !== idx) return null;
	if(!tableData.leaderboard) return null;

	return(<div className={'table flex flex-wrap mt0' + (tableData.leaderboard.length > 0 ? ' mb5' : '')}>
		{type !== ('Team') &&
			<div className="top-of-table w-100 h-100">
				<div className="autocomplete w-100">
					<div className="input-reset parent flex items-center justify-between relative ph2">
						<input
							value={searchTerm}
							className="input-reset ba b--black-20 pa2 db w-third"
							onChange={(e) => setSearchTerm(e.target.value)}
						/>
						<div className="search-icon absolute left-0 top-0 w1 h1 o-70">
							<svg id="search-2" enableBackground="new 0 0 515.558 515.558" viewBox="0 0 515.558 515.558"><path d="m378.344 332.78c25.37-34.645 40.545-77.2 40.545-123.333 0-115.484-93.961-209.445-209.445-209.445s-209.444 93.961-209.444 209.445 93.961 209.445 209.445 209.445c46.133 0 88.692-15.177 123.337-40.547l137.212 137.212 45.564-45.564c0-.001-137.214-137.213-137.214-137.213zm-168.899 21.667c-79.958 0-145-65.042-145-145s65.042-145 145-145 145 65.042 145 145-65.043 145-145 145z"/></svg>
						</div>
						{autoCompleteResults.length > 0 &&
							<div className="auto-results absolute w-third bg-white tl">
								{(autoCompleteResults || []).map((result, idx) => 
									<div 
										onClick={getMemberPage.bind(this, result)}
										className="result pa3 bb">
										{result.gym_name || result.member_name}
									</div>
								)}
							</div>
						}
						<div className="refresh-leaderboard">
							<div 
								className="btn bg-blue white ph3 pv2 pointer"
								onClick={getData.bind(this)}>
								reset
							</div>
						</div>
					</div>
				</div>
				<div className="table-header dn flex-ns w-100">
					<div className="w-40 tl ph3  pt3 pb3 tc">
						{type}
					</div>
					<div className="divider">
					</div>
					<div className="w-60 tc pt3 pb3">
						Movement Reps/Distance
					</div>
				</div>
			</div>
		}
		{(type !== 'Team') &&
			<div className="w-100">
				{(tableData.leaderboard || []).map((member, idx) => 
					<TableRow 
						key={idx}
						member={member}
						index={idx}
						page={page}
					/>
				)}
				<div className="prev-next btns flex w-100">
					<div className="w-50">
						{(page !== 1) &&
							<div 
								onClick={setPage.bind(this, page - 1)}
								className="prev w-100 pa3 tc pointer bg-black white flex w-100 items-center justify-center tc">
								<svg version="1.1" id="arrow-2" width="16" height="16" x="0px" y="0px" viewBox="0 0 31.494 31.494" style={{enableBackground: 'new 0 0 31.494 31.494', paddingRight: '12px'}}><path style={{fill: '#fff'}} d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554  c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587  c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"/></svg> Prev
							</div>
						}
					</div>
					<div className="w-50">
						{(tableData.leaderboard.length > 19) &&
							<div 
								onClick={setPage.bind(this, page + 1)}
								className="next w-100 pa3 tc pointer bg-black white flex w-100 items-center justify-center tc">
								Next <svg version="1.1" id="arrow-1" width="16" height="16" x="0px" y="0px" viewBox="0 0 31.49 31.49" style={{enableBackground:'new 0 0 31.49 31.49', paddingLeft: '12px'}}><path style={{fill:'#fff'}} d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111  C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587  c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"/></svg>
							</div>
						}
					</div>
				</div>
			</div>
		}

		{(type === 'Team') &&
			(tableData.leaderboard || []).map((team, idx) => 
				<TeamTableRow 
					key={idx}
					team={team}
					index={idx}
					page={page}
				/>
			)
		}

		{(tableData.leaderboard.length < 1 && !loading) &&
			<h2 className="tc mt4 w-100">
				No results yet!
			</h2>
		}
	</div>);
}

export default Table;